// Ссылка-приглашение: страница входа с кодом игрока. Бэкенд запишет, кто позвал нового
// игрока, когда тот впервые войдёт через Steam. Кода ещё нет — просто страница входа.
export const inviteLink = (origin: string, code: string | null): string =>
  code === null ? `${origin}/login` : `${origin}/login?ref=${encodeURIComponent(code)}`;
